export default "__VITE_ASSET__28959215__"